import React from "react";
import { ShieldCheckIcon, CheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { guaranteeSteps } from "../../data/landing";
export function WhyPriceGuarantee() {
  return <>
      <section className="bg-white px-4 py-16 sm:py-20" data-id="element-303" data-mp="32pu0to2bl4mf">
        <div className="mx-auto max-w-2xl text-center" data-id="element-304" data-mp="2xrsi548t37bh">
          <h2 className="font-display text-3xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-305" data-mp="2xr8y9hzli8ut">
            Why did I price it at <em className="italic text-skydeep" data-id="element-306" data-mp="2ts9xm9kwcy96">$27?</em>
          </h2>
          <p className="mt-5 text-[18px] font-semibold leading-relaxed text-navy" data-id="element-307" data-mp="2oyoww9rx5q6a">
            Because I don't want the price to be the reason you don't practice.
          </p>
          <p className="mt-4 text-[17px] leading-relaxed text-ink/75" data-id="element-308" data-mp="2f22cfm3i914s">
            I created this as a practical entry-level case-training system, not as a replacement for advanced surgical education. Use it repeatedly. Print the worksheets. Work through the cases. Compare your thinking. Build your own case library — and return to the framework whenever you want.
          </p>
          <div className="mt-10" data-id="element-309" data-mp="10lgcp86zgxeq">
            <CTAButton label="Start your Case Lab today" data-id="element-310" data-mp="10mhzg9xd38ca" />
          </div>
        </div>
      </section>

      <section className="bg-cream px-4 py-16 sm:py-20" data-id="element-311" data-mp="ly4xmwblev9v">
        <div className="mx-auto max-w-3xl rounded-3xl bg-white p-6 shadow-sm ring-1 ring-navy/10 sm:p-10" data-id="element-312" data-mp="qvnagxsqdun5">
          <div className="flex flex-col items-center text-center" data-id="element-313" data-mp="1ekzjnxo262pg">
            <span className="flex h-20 w-20 items-center justify-center rounded-full bg-navy text-sky" data-id="element-314" data-mp="1ejof3vmsgqxa">
              <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-315" data-mp="1ji7zhrlqhunj" />
            </span>
            <h2 className="mt-5 font-display text-3xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-316" data-mp="15n5mylmdt71r">7-Day Guarantee</h2>
            <p className="mt-4 text-[17px] leading-relaxed text-ink/75" data-id="element-317" data-mp="3qba97ekbzjz8">
              I want you to be able to explore Liposuction Case Lab™ without unnecessary risk. You have 7 days to:
            </p>
          </div>
          <ul className="mx-auto mt-5 max-w-md space-y-2.5" data-id="element-318" data-mp="20u6cjtjju2xd">
            {guaranteeSteps.map(s => <li key={s} className="flex items-center gap-3 text-[16px] font-semibold text-navy" data-id="element-319" data-mp="1vvv15edlvkd1">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-320" data-mp="1r31wsrm1ue1h">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-321" data-mp="1m4h3zd94mwn2" />
                </span>
                {s}
              </li>)}
          </ul>
          <p className="mx-auto mt-6 max-w-xl text-center text-[16px] leading-relaxed text-ink/75" data-id="element-322" data-mp="1d3srwo3an6ct">
            If you decide it's not useful for your professional learning, contact us within the guarantee period according to the purchase terms and request a refund. <strong className="text-navy" data-id="element-323" data-mp="1388ws3wk0bp4">No complicated process.</strong>
          </p>
          <div className="mt-8" data-id="element-324" data-mp="32iqkxmb1hj3v">
            <CTAButton label="Try it risk-free for 7 days" data-id="element-325" data-mp="2xk5si92143pz" />
          </div>
        </div>
      </section>
    </>;
}